import { QueryClient } from "@tanstack/vue-query"
import { ApiError } from "@/services/api"
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      refetchInterval: false,
      refetchOnWindowFocus: false,
      retry: (failureCount: number, error) => {
        if (
          error instanceof ApiError &&
          error.status === 404
        )
          return false

        if (failureCount >= 3) return false

        return true
      },
    },
  },
})
